import { Injectable } from '@angular/core';
import { ApiInterface } from '../api-interface';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { RelatorioVendasParams } from '../../models/relatorios/relatorio-vendas.model';

@Injectable({
  providedIn: 'root',
})
export class RelatorioVendasService implements ApiInterface {

  constructor(private apiService: ApiService) { }

  // Método GET genérico (da interface ApiInterface)
  get<T>(url: string, data?: any): Observable<any> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<any>(patch);
  }
  getText<T>(url: string, data?: any): Observable<any> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.readText<any>(patch);
  }
  getById<T>(url: string): Observable<any> {
    throw new Error('Method not implemented.');
  }
  post<T>(url: string, data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  put<T>(url: string, data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  delete<T>(url: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  // Método auxiliar para chamar o relatório
  emitirRelatorioVendas(params: RelatorioVendasParams): Observable<string> {
    return this.getText<string>('/relatorios/relatorio-de-vendas', params);
  }
}
